import type { Action } from 'state/actions';

import type { UnderlyingHistoModalState } from './underlyingHisto.model';
import { initialUnderlyingHistoModalState } from './underlyingHisto.model';

export function underlyingHistoReducer(
  state: UnderlyingHistoModalState = initialUnderlyingHistoModalState,
  action: Action,
): UnderlyingHistoModalState {
  switch (action.type) {
    case 'UNDERLYING_HISTORICS_REQUESTED':
      return {
        ...state,
        isFetching: true,
        isFetchingFailed: false,
      };

    case 'UNDERLYING_HISTORICS_FETCHED':
      return {
        ...state,
        isFetching: false,
        isFetchingFailed: false,
        underlyingsHistorics: action.historics,
      };

    case 'UNDERLYING_HISTORICS_FETCH_FAILED':
      return {
        ...state,
        isFetching: false,
        isFetchingFailed: true,
        errorMessage: action.error,
      };

    default:
      return state;
  }
}
